import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "../Hooks/useIsPropertiesPanelRevamp";

export interface RightSidebarProps extends ComponentPropsWithoutRef<"aside"> {
  children: ReactNode;
  className?: string;
}

export const RightSidebar = ({
  children,
  className,
  ...rest
}: RightSidebarProps) => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  return (
    <aside
      className={classNames(
        "text-default bg-primary divide-primary border-primary relative flex h-full flex-col divide-y overflow-y-auto border-l [grid-area:right-sidebar]",
        {
          "w-72": !isPropertiesPanelV2,
          "w-[19.25rem]": isPropertiesPanelV2,
        },
        className,
      )}
      data-testid="builder-ui-right-sidebar"
      {...rest}
    >
      {children}
    </aside>
  );
};
